import { useEffect } from 'react';
import { useT } from './i18n';
import { useSession } from './session';

/**
 * Panelin görünen adı (F12-12, spesifikasyon §0): İşletme Bilgileri → Varsayılanlar → "Panel adı". Etkin işletmede
 * girilmişse o ad, değilse varsayılan ad. Giriş ekranı oturumdan önce açıldığı için son görülen ad bu tarayıcıda
 * hatırlanır (yalnızca kolaylık; erişilemezse varsayılan ad).
 */
const KEY = 'zt-system-name';

export function rememberedSystemName(): string | null {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function useSystemName(): string {
  const t = useT();
  const session = useSession();
  const active = session.data?.memberships.find(
    (m) => m.organizationId === session.data?.session.activeOrganizationId,
  );
  const name = active?.systemName?.trim() || t('admin.auth.brand');
  useEffect(() => {
    if (!session.data) return;
    document.title = name;
    try {
      if (active?.systemName) window.localStorage.setItem(KEY, active.systemName);
      else window.localStorage.removeItem(KEY);
    } catch {
      /* depo kapalı */
    }
  }, [name, active?.systemName, session.data]);
  return name;
}
